import Vue from 'vue'
import {isFullWidthChar} from "@/common/helpers/validation";

Vue.directive('remove-fullwidth-character', function (el, binding, vnode) {
    const handler = function (e) {
        let sanitizedInput = "";
        const value = e.target.value;
        const newValue = value.replace(/\s+/g, '') //remove space

        for (let i = 0; i < newValue.length; i++) {
            if (!isFullWidthChar(newValue.charCodeAt(i))) {
                sanitizedInput += newValue[i];
            }
        }
        if (sanitizedInput !== value) {
            e.target.value = sanitizedInput
            vnode.elm.dispatchEvent(new CustomEvent('input'))
        }
    };
    el.addEventListener('input', handler)
});
